const cssStyles = () => `
.red.active:focus,
.red.active:hover {
  background-color: #d50c22 !important;
}
.lightGrey.active:focus,
.lightGrey.active:hover {
  background-color: #f5f3f3 !important;
}
.darkGrey.active:focus,
.darkGrey.active:hover {
  background-color: #5e5e5e !important;
}
.blueTransparent.active:focus,
.blueTransparent.active:hover {
  background-color: #0077e6 !important;
}
.white.active:focus,
.white.active:hover {
  background-color: #e6e6e6 !important;
}
@keyframes loadingSpinner {
  to {transform: rotate(360deg);}
}

.loadingSpinner:before {
  content: '';
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  margin-left: -10px;
  border-radius: 50%;
  border-top: 2px solid white;
  border-right: 2px solid transparent;
  animation: loadingSpinner 1s linear infinite;
}
`;

export default cssStyles;
